import { Box, Typography } from '@mui/material';
import { sortBy, uniqBy } from 'lodash-es';
import * as api from '../../../../lib/api.js';
import { useContext } from '../../context.jsx';
import { useGrowers } from '../../../../hooks/use-growers.js';
import ConfirmationDialog from '../../../../components/ConfirmationDialog/ConfirmationDialog.jsx';
import { useDeleteContext } from './delete-context.jsx';

export function DeleteDialog() {
  const { isConfirming, setConfirming } = useDeleteContext();
  const { getSelectedInstances, removeInstance } = useContext();
  const instances = uniqBy(getSelectedInstances(), 'id');
  const ids = instances.map((i) => i.id);
  const { selectedId: growerId } = useGrowers();

  return isConfirming ? (
    <ConfirmationDialog
      title="Delete Instance"
      titleIcon={false}
      renderBody={() => (
        <Box sx={{ '& ul': { p: 0, listStyle: 'none' } }}>
          <Typography>
            You are about to permanently delete the instance(s):
          </Typography>
          <ul>
            {sortBy(instances, 'name').map((i) => (
              <li key={i.id}>
                <Typography sx={{ fontWeight: 'bold' }}>{i.name}</Typography>
              </li>
            ))}
          </ul>
          <Typography>Do you wish to continue with the delete?</Typography>
        </Box>
      )}
      handleClose={closeConfirmation}
      handleConfirm={deleteThem}
    />
  ) : null;

  function closeConfirmation() {
    setConfirming(false);
  }

  function deleteThem() {
    return api
      .deleteLpkInstances(growerId, ids)
      .then(closeConfirmation)
      .then(() => removeInstance(ids));
  }
}
